import { FC } from "react";

import { Button, Typography } from "@/shared/ui";
import { useUIStore } from "@/stores";

import styles from "./confirm-logout.module.scss";
import { ConfirmLogoutProps } from "./confirm-logout.types";

const ConfirmLogout: FC<ConfirmLogoutProps> = ({ onSubmit }) => {
  const closeModal = useUIStore((state) => state.actions.modal.closeModal);

  return (
    <div className={styles.logoutConfirmationModal}>
      <Typography semi align="center" variant="body" className={styles.title}>
        Log Out?
      </Typography>

      <Typography align="center" variant="footnote" className={styles.description}>
        Are you sure you want to log out of your account?
      </Typography>

      <div className={styles.footer}>
        <Button
          fullWidth
          variant="secondary"
          size="big"
          onClick={() => {
            closeModal();
          }}
        >
          Cancel
        </Button>

        <Button
          fullWidth
          variant="primary"
          size="big"
          type="button"
          className={styles.confirmButton}
          onClick={() => {
            onSubmit();
            closeModal();
          }}
        >
          Confirm
        </Button>
      </div>
    </div>
  );
};

export { ConfirmLogout };
